import Information16 from '@carbon/icons-react/es/information/16';
import { Tooltip } from 'antd';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Caption01, ProductiveHeading05 } from 'components/styles';

const Wrapper = styled.div`
  min-width: 136px;
`;

const Title = styled.div`
  ${Caption01};
  display: inline-block;
  color: #000;
  opacity: 0.7;
  margin-bottom: var(--spacing-03);
`;

const Value = styled.div`
  ${ProductiveHeading05};
  color: #000;
`;

interface Props {
  title: string | ReactNode;
  value: string | ReactNode;
  className?: string;
}

export const Summary: FC<Props> = ({ title, value, className }) => {
  return (
    <Wrapper className={className}>
      <Title>{title}</Title>
      <Value>{value}</Value>
    </Wrapper>
  );
};

const UtilizationTitleWrapper = styled.div`
  display: flex;

  svg {
    margin-left: var(--spacing-03);
  }
`;

export const UtilizationTitle: FC = () => (
  <UtilizationTitleWrapper>
    <FormattedMessage id="timesheets.summary.utilization" />
    <Tooltip
      overlayStyle={{ maxWidth: '500px' }}
      title={<FormattedMessage id="timesheets.summary.tooltips.utilization" />}
    >
      <Information16 />
    </Tooltip>
  </UtilizationTitleWrapper>
);
